import BaseVisualizationService from '@configuratorware/configurator-frontendgui/App/Services/VisualizationService';
import { getConf } from '@configuratorware/configurator-frontendgui/App/configuration';
import { createAdapterConfig } from 'redhotmagma-visualization/visualizationAdapterCreator';
import Visualization from '../Visualization/VisualizationWithInstances';
import { Services } from '@configuratorware/configurator-frontendgui/App/ServiceLocator';
import isEqual from 'lodash/isEqual';
import { CustomEventTypes } from '../Visualization/Constants';
import { setSelectedInstanceId } from '../Reducers/MachineInstance/Actions';

const getComponentIdentifiersDeep = (componentRoot) => {
  if (!componentRoot?.identifier) {
    return null;
  }
  return [
    ...new Set([
      ...(componentRoot.identifier ? [componentRoot.identifier] : []),
      ...(componentRoot.entries ? componentRoot.entries.map(getComponentIdentifiersDeep).flat() : []),
    ]),
  ];
};

class VisualizationService extends BaseVisualizationService {
  adapterConfig = createAdapterConfig(
    { host: getConf('network.host') },
    {
      '3dVariant': {
        adapterClass: Visualization,
      },
      '3dScene': {
        adapterClass: Visualization,
      },
    }
  );

  init() {
    super.init();

    Services.store.observeStore(
      (state) => getComponentIdentifiersDeep(state.ipco.selectedComponent),
      (componentIdentifiers) => {
        const component = this.getComponent();
        componentIdentifiers &&
          component &&
          component.updateSelectedArea &&
          component.updateSelectedArea({
            componentIdentifiers,
          });
      },
      isEqual
    );
    Services.store.observeStore(
      (state) => state.ipco.selectedConfiguratorMenu,
      (mainGroupIdentifier, prevMainGroupIdentifier) => {
        const visualizationComponent = this.getComponent();
        if (!visualizationComponent) {
          return;
        }
        if (mainGroupIdentifier === 'surroundings') {
          visualizationComponent.toggleSurroundings(true);
        }
        if (prevMainGroupIdentifier === 'surroundings') {
          visualizationComponent.toggleSurroundings(false);
        }
        mainGroupIdentifier &&
          visualizationComponent.updateSelectedArea({
            mainGroupIdentifier,
            fallbackToDefault: true,
          });
      }
    );
  }

  setComponent(component) {
    super.setComponent(component);
    component.observable.on(CustomEventTypes.SelectedInstanceChanged, (event) => {
      Services.store.dispatch(setSelectedInstanceId(event.data.selectedInstanceId));
    });
  }

  resetCurrentView(options = {}) {
    const visualizationComponent = this.getComponent();
    const {
      clearComponent = !Services.store.state.ipco.selectedComponent?.identifier /* no component selected */,
    } = options;
    visualizationComponent &&
      visualizationComponent.resetCurrentView({ clearComponent, fallbackToDefault: true });
  }
}

export default VisualizationService;
